import * as React from "react";
import styles from "./loading_placeholder.module.sass";

export const LoadingPlaceholder = (): JSX.Element => (
  <div className={styles.loadingContainer}>
    <div className={styles.sidebarPlaceholder}>
      <div className={styles.sidebarLoadingTop}>
        <div className={styles.sidebarSmallLine} />
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
      </div>
      <div className={styles.sidebarLoadingMiddle}>
        <div className={styles.sidebarSmallLine} />
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
      </div>
      <div className={styles.sidebarLoadingBottom}>
        <div className={styles.sidebarSmallLine} />
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
        <div className={styles.sidebarCircleLine}>
          <div className={styles.sidebarCircle} />
          <div className={styles.sidebarNormalLine} />
        </div>
      </div>
    </div>
    <div className={styles.productsPlaceholder} id="products-placeholder">
      <div className="categories-box-loading">
        <div className="categories-loading">
          <div className="top-lines-container" />
          <div className="loading-line" />
          <div className="loading-line" />
          <div className="camera-container">
            <div className="camera-top" />
            <div className="camera-main">
              <div className="camera-circle_detail" />
              <div className="camera-circle_big">
                <div className="camera-circle_small" />
              </div>
            </div>
          </div>
          <div className="small_lines_container">
            <div className="loading-line small" />
            <div className="loading-line small" />
          </div>
          <div className="bottom_lines">
            <div className="loading-line normal" />
            <div className="loading-line normal" />
            <div className="loading-line normal" />
          </div>
          <div className="big-line-container">
            <div className="loading-line big" />
          </div>
        </div>
        <div className="categories-loading">
          <div className="top-lines-container" />
          <div className="loading-line" />
          <div className="loading-line" />
          <div className="camera-container">
            <div className="camera-top" />
            <div className="camera-main">
              <div className="camera-circle_detail" />
              <div className="camera-circle_big">
                <div className="camera-circle_small" />
              </div>
            </div>
          </div>
          <div className="small_lines_container">
            <div className="loading-line small" />
            <div className="loading-line small" />
          </div>
          <div className="bottom_lines">
            <div className="loading-line normal" />
            <div className="loading-line normal" />
            <div className="loading-line normal" />
          </div>
          <div className="big-line-container">
            <div className="loading-line big" />
          </div>
        </div>
        <div className="categories-loading">
          <div className="top-lines-container" />
          <div className="loading-line" />
          <div className="loading-line" />
          <div className="camera-container">
            <div className="camera-top" />
            <div className="camera-main">
              <div className="camera-circle_detail" />
              <div className="camera-circle_big">
                <div className="camera-circle_small" />
              </div>
            </div>
          </div>
          <div className="small_lines_container">
            <div className="loading-line small" />
            <div className="loading-line small" />
          </div>
          <div className="bottom_lines">
            <div className="loading-line normal" />
            <div className="loading-line normal" />
            <div className="loading-line normal" />
          </div>
          <div className="big-line-container">
            <div className="loading-line big" />
          </div>
        </div>
      </div>
    </div>
  </div>
);
